/**
 * Report table presentation — reuse Contacts / Campaigns table language.
 */
import type { CSSProperties } from "react";
import {
  contactsTableBodyCellClass,
  contactsTableBodyRowClass,
  contactsTableClass,
  contactsTableHeaderCellClass,
  contactsTableHeaderIconWrapClass,
  contactsTableHeaderLabelClass,
  contactsTableHeadRowClass,
  contactsTableShellClass,
  contactsValueChipClass,
} from "../contacts/contacts-table-presentation.js";

export {
  contactsTableBodyCellClass,
  contactsTableBodyRowClass,
  contactsTableClass,
  contactsTableHeaderCellClass,
  contactsTableHeaderIconWrapClass,
  contactsTableHeaderLabelClass,
  contactsTableHeadRowClass,
  contactsTableShellClass,
  contactsValueChipClass,
};

/** Outer shell for report tables (Contacts visual language). */
export const reportTableWorkspaceClass = `${contactsTableShellClass} flex min-h-0 flex-1 flex-col overflow-hidden`;

export const reportTableScrollClass =
  "min-h-0 flex-1 overflow-auto overscroll-contain [scrollbar-gutter:stable]";

export const reportTableClass = `${contactsTableClass} min-w-0`;

export const reportTableHeadRowClass = `${contactsTableHeadRowClass} sticky top-0 z-[1]`;

export const reportTableHeaderCellClass = `relative ${contactsTableHeaderCellClass}`;

export const reportTableBodyRowClass = `${contactsTableBodyRowClass} data-[clickable=true]:cursor-pointer`;

export const reportTableBodyCellClass = contactsTableBodyCellClass;

export const reportResizeHandleClass =
  "absolute end-0 top-0 z-[2] h-full w-1.5 cursor-col-resize touch-none bg-transparent hover:bg-accent/30";

export function reportColumnStyle(width: number): CSSProperties {
  return {
    width,
    minWidth: width,
    maxWidth: width,
  };
}
